module.exports = __webpack_public_path__ + "static/media/simpledb-indexsnippet.a12aff05.png";